module.exports = __webpack_public_path__ + "img/platby.418dab4a.svg";